import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Reads /api/trial-window. Returns { trialOpen, cutoffIso, loading }.
 * `trialOpen` defaults to true until loaded so trial copy never flashes
 * "ended" for the split second before the request resolves.
 */
export function useTrialWindow() {
  const [state, setState] = useState({ trialOpen: true, cutoffIso: null, loading: true });
  useEffect(() => {
    let alive = true;
    api
      .get("/trial-window")
      .then((r) => {
        if (alive) setState({ trialOpen: !!r.data?.trial_open, cutoffIso: r.data?.cutoff_iso || null, loading: false });
      })
      .catch(() => {
        if (alive) setState((s) => ({ ...s, loading: false }));
      });
    return () => { alive = false; };
  }, []);
  return state;
}
